import { type Editor } from '@tiptap/react';
import { BubbleMenu as BM } from '@tiptap/react/menus';

import { Separator } from '../../../primitives/separator';

import { ButtonEraser, ERASER_TYPE } from '../commands/button-eraser';
import { ButtonUnlink } from '../commands/button-unlink';
import { ToggleBold } from '../commands/toggle-bold';
import { ToggleItalic } from '../commands/toggle-italic';
import { ToggleLink } from '../commands/toggle-link';
import { ToggleStrike } from '../commands/toggle-strike';
import { ToggleUnderline } from '../commands/toggle-underline';
import { EDITOR_CONTROLS, type EditorControl } from '../controls';

interface BubbleMenuProps {
  controls?: EditorControl[];
  editor: Editor;
}

export function BubbleMenu({ controls, editor }: BubbleMenuProps) {
  const show = (control: EditorControl) => !controls || controls.includes(control);

  return (
    <BM className="flex gap-1 rounded-full bg-background p-1 drop-shadow-sm" editor={editor}>
      {show(EDITOR_CONTROLS.toggleBold) && <ToggleBold editor={editor} />}
      {show(EDITOR_CONTROLS.toggleItalic) && <ToggleItalic editor={editor} />}
      {show(EDITOR_CONTROLS.toggleStrike) && <ToggleStrike editor={editor} />}
      {show(EDITOR_CONTROLS.toggleUnderline) && <ToggleUnderline editor={editor} />}
      {show(EDITOR_CONTROLS.toggleLink) && <ToggleLink editor={editor} />}
      {show(EDITOR_CONTROLS.toggleLink) && <ButtonUnlink editor={editor} />}
      <Separator className="h-auto" orientation="vertical" />
      <ButtonEraser editor={editor} type={ERASER_TYPE.marks} />
    </BM>
  );
}
